import React from 'react';

import { SOLUTION_CARDS } from '../../constants';
import SolutionCard from './SolutionCard';

import styles from './styles.module.css';

const SolutionsGrid: React.FC = () => (
  <section className={styles.solutions} id="solutions">
    <div className={styles.shell}>
      <div className={styles.head}>
        <div className={styles.eyebrow}>Our solutions</div>
        <h2 className={styles.heading}>
          Four ways we <em>partner with brands.</em>
        </h2>
      </div>

      <div className={styles.grid}>
        {SOLUTION_CARDS.map((card) => (
          <SolutionCard
            key={card.id}
            variant={card.variant}
            tag={card.tag}
            title={card.title}
            description={card.description}
            bullets={card.bullets}
          />
        ))}
      </div>
    </div>
  </section>
);

export default SolutionsGrid;
